<template>
  <div class="rise-in max-w-md mx-auto">
    <router-link
      class="link-brand inline-flex items-center gap-1.5 text-sm mb-4"
      :to="{ name: 'Dashboard' }"
    >
      <font-awesome-icon icon="arrow-left" /> Projects
    </router-link>
    <div class="card card-pad">
      <h1 class="page-title">Patient check-in</h1>
      <p class="page-subtitle mb-6 flex items-center gap-2">
        Project
        <span class="pill pill-brand uppercase">{{ projectSlug }}</span>
      </p>

      <FormulateForm class="space-y-4" @submit="onCheckIn">
        <FormulateInput
          v-model="patientId"
          type="text"
          name="patientId"
          label="Patient ID"
          :placeholder="placeholder"
          help="Format: xxx-xxx-00000 (e.g. USZ-BEX-00065)"
          validation="required|matches:/^[A-Za-z]{3}-[A-Za-z]{3}-[0-9]{5}$/"
          :validation-messages="{ matches: 'Expected format xxx-xxx-00000.' }"
          data-cypress="checkin.patientId"
        />
        <FormulateInput
          type="submit"
          :label="loading ? 'Checking in…' : 'Check in'"
          :disabled="loading"
        />
      </FormulateForm>

      <p v-if="error" class="text-red-600 text-sm mt-3">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { actionTypes, getterTypes } from 'store/patient'

export default {
  name: 'CheckIn',
  data() {
    return { patientId: '', error: null }
  },
  computed: {
    ...mapGetters({ loading: getterTypes.loading }),
    projectSlug() {
      return this.$route.params.projectSlug
    },
    // Subject numbers are USZ-<PROJECT>-000XX, so pre-fill everything up to the
    // last two digits the operator still has to type.
    prefix() {
      return `USZ-${(this.projectSlug || '').toUpperCase()}-000`
    },
    placeholder() {
      return `usz-${this.projectSlug}-00001`
    },
  },
  created() {
    // Seed the field with the project prefix (operator only types the final 2 digits).
    this.patientId = this.prefix
  },
  mounted() {
    // Focus the input and drop the caret at the end so typing continues the number.
    this.$nextTick(() => {
      const el = this.$el.querySelector('input')
      if (el) {
        el.focus()
        const len = el.value.length
        el.setSelectionRange(len, len)
      }
    })
  },
  methods: {
    async onCheckIn() {
      this.error = null
      try {
        const patient = await this.$store.dispatch(
          actionTypes.checkInPatient,
          this.patientId
        )
        this.$router.push({
          name: 'PatientOverview',
          params: {
            projectSlug: patient.project_id,
            patientId: patient.patient_id,
          },
        })
      } catch (e) {
        this.error =
          (e.response &&
            e.response.data &&
            (e.response.data.error || e.response.data.message)) ||
          e.message ||
          'Check-in failed.'
      }
    },
  },
}
</script>
